import React from 'react';
import BackOfficeMenu from './BackOfficeMenu';
import './AccessDenied.css';

const AccessDenied = ({module, onNavigate, onLogout, currentPage}) => {
    return (
        <div className="access-denied-layout">
            <BackOfficeMenu
                onNavigate={onNavigate}
                onLogout={onLogout}
                currentPage={currentPage}
            />
            <div className="access-denied-container">
                <div className="access-denied-card">
                    <div className="access-denied-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                            <line x1="12" y1="16" x2="12" y2="16"></line>
                        </svg>
                    </div>
                    <h1>Accès Refusé</h1>
                    <p>
                        Désolé, vous n'avez pas les permissions nécessaires pour accéder au module
                        <strong> {module || 'demandé'}</strong>.
                    </p>
                    <p className="contact-admin">
                        Si vous pensez qu'il s'agit d'une erreur, veuillez contacter l'administrateur système.
                    </p>
                    <div className="access-denied-actions">
                        <p>Veuillez utiliser le menu latéral pour naviguer vers une autre section.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccessDenied;
